import { ReadUser } from "@/types/user";
import { useUsersContext } from "../context";

/**
 * Hook to get user data from context
 * Throws error if loading, error, or no data
 */
export const useUserData = (): ReadUser => {
  const { data, loadingState, errorState } = useUsersContext();

  if (loadingState.isLoading) {
    throw new Error("User data is still loading");
  }
  if (errorState.error) {
    throw errorState.error;
  }
  if (!data) {
    throw new Error("No user data available");
  }

  return data;
};
